import { Button } from "primereact/button";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { Dropdown } from 'primereact/dropdown';
import { InputText } from "primereact/inputtext";
import React, { useState } from "react";
import { BsExclamationCircle } from "react-icons/bs";
import { Api } from "../../../../services/api";
import { ConfirmDialogPague } from "../../../../styles/primeReactConfig";
import { confirmFooter } from "../../../confirmFooter";

export const InaCobranca = ({ close, rowInfo, reload, toast }) => {
    const [inativaContrato, setInativaContrato] = useState();
    const [inativaAcordo, setInativaAcordo] = useState();
    const [inativaVara, setInativaVara] = useState();
    const [selectedFilterEstado, setSelectedFilterEstado] = useState('')
    const [showConfirmInativar, setShowConfirmInativar] = useState(false);

    const filterOptionsEstados = [
        { value: 'AC', label: 'ACRE' },
        { value: 'AL', label: 'ALGOAS' },
        { value: 'AP', label: 'AMAPÁ' },
        { value: 'AM', label: 'AMAZONAS' },
        { value: 'BA', label: 'BAHIA' },
        { value: 'CE', label: 'CEARÁ' },
        { value: 'DF', label: 'DISTRITO FEDERAL' },
        { value: 'ES', label: 'ESPÍRITO SANTO' },
        { value: 'GO', label: 'GOIÁS' },
        { value: 'MA', label: 'MARANHÃO' },
        { value: 'MT', label: 'MATO GROSSO' },
        { value: 'MS', label: 'MATO GROSSO DO SUL' },
        { value: 'MG', label: 'MINAS GERAIS' },
        { value: 'PA', label: 'PARÁ' },
        { value: 'PB', label: 'PARAÍBA' },
        { value: 'PR', label: 'PARANÁ' },
        { value: 'PE', label: 'PERNAMBUCO' },
        { value: 'PI', label: 'PIAUÍ' },
        { value: 'RJ', label: 'RIO DE JANEIRO' },
        { value: 'RN', label: 'RIO GRANDE DO NORTE' },
        { value: 'RS', label: 'RIO GRANDE DO SUL' },
        { value: 'RO', label: 'RONDÔNIA' },
        { value: 'RR', label: 'RORAIMA' },
        { value: 'SC', label: 'SANTA CATARINA' },
        { value: 'SP', label: 'SÃO PAULO' },
        { value: 'SE', label: 'SERGIPE' },
        { value: 'TO', label: 'TOCANTINS' }
    ];

    const handleInativar = async () => {

        try {
            await Api.post('/cobranca/inativacao', {
                cobranca_id: rowInfo.cobranca_id,
                cobranca_contrato: inativaContrato,
                cobranca_acordo_judicial: inativaAcordo,
                cobranca_vara: inativaVara,
                cobranca_estado: selectedFilterEstado,
            });
            close();
            await reload();
            toast('success', 'Cobrança inativada com sucesso!');
        } catch (error) {
            console.error(error);
            toast('error', 'Error ao inativar cobrança.');
        }
    };




    return (<>
        <Dialog
            header="Inativar Cobrança"
            visible
            style={{
                minHeigth: '30vw',
                minWidth: '20vw',
                textAlign: 'center'
            }}
            onHide={() => close()}
        >       <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '2rem',
            }}
        >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '1.5rem',
                        width: '100%',
                        paddingTop: '2rem',
                    }}
                >
                    <span className="p-float-label" style={{ width: '100%' }}>
                        <InputText
                            style={{ width: '100%' }}
                            id="inativa_contrato"
                            onChange={(e) => setInativaContrato(e.target.value)}
                            required
                        />
                        <label htmlFor="inativa_contrato">Contrato</label>
                    </span>
                    <span className="p-float-label" style={{ width: '100%' }}>
                        <InputText
                            name="inativa_acordo_judicial"
                            style={{ width: '100%' }}
                            onChange={(e) =>
                                setInativaAcordo(e.target.value)
                            }
                            required
                        />
                        <label htmlFor="inativa_acordo_judicial">Acordo judicial</label>
                    </span>
                    <span className="p-float-label" style={{ width: '100%' }}>
                        <InputText
                            style={{ width: '100%' }}
                            id="inativa_vara"
                            onChange={(e) => setInativaVara(e.target.value)}
                            required
                        />
                        <label htmlFor="inativa_vara">Vara</label>
                    </span>
                    <span className="p-float-label" style={{ width: '100%' }}>
                        <Dropdown
                            className='w-12'
                            id='inativa_Estado'
                            value={selectedFilterEstado}
                            options={filterOptionsEstados}
                            onChange={(e) => {
                                setSelectedFilterEstado(e.target.value);
                            }}
                            required
                            style={{ textAlign: 'left' }}
                        />
                        <label htmlFor="inativa_Estado">Estado</label>
                    </span>
                </div>
                <Button
                    id="inativar"
                    label="inativar"
                    severity="info"
                    style={{ borderRadius: '0.25rem' }}
                    onClick={() => { setShowConfirmInativar(true) }}
                />
                <ConfirmDialog
                    visible={showConfirmInativar}
                    onHide={() => setShowConfirmInativar(false)}
                    header={'Inativar Cobrança'}
                    message={`Deseja realmente inativar essa cobraça?`}
                    pt={ConfirmDialogPague}
                    icon={<BsExclamationCircle/>}
                    acceptLabel="Sim"
                    rejectLabel="Não"
                    accept={handleInativar}
                    reject={() => setShowConfirmInativar(false)}
                    footer={confirmFooter}
                />
            </div>
        </Dialog>
    </>
    )
}